import * as React from "react";
import Drawer from "@mui/material/Drawer";
import {
  Box,
  Button,
  IconButton,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import bfLogo from "../../assets/images/utsav-pack-logo.png";
import CartAddressList from "./address/CartAddressList";
import { reorderAddresses } from "./cartUtil";
import { useState } from "react";
import { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";

import { NavLink } from "react-router";
import { useAuth } from "../../hooks/AuthContext";
import { AddressBook, X } from "@phosphor-icons/react";
import GstInvoice from "./gst/GstInvoice";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function CartSideNav({
  toggleSelecteAddressDrawer,
  addressList,
  primaryAddress,
  primaryAddressRefetch,
  selectedAddress,
  setSelectedAddress,
  addressListFetch,
  gstInvoiceDetails,
  setGstInvoiceDetails,
}) {
  const {
    setAddressDialogOpen,
    setAddressCreateFrom,
    selectAddressDrawer,
  } = useAuth();
  const [openGstDialog, setOpenGstDialog] = useState(false);
  // const [gstInvoiceDetails, setGstInvoiceDetails] = useState({
  //   gstin: "",
  //   business_name: "",
  // });

  const [localAddressList, setLocalAddressList] = useState(addressList);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (selectAddressDrawer) {
      const reorderedAddresses = selectAddressDrawer
        ? reorderAddresses(addressList, primaryAddress?.customer_address_id)
        : addressList;
      setLocalAddressList(reorderedAddresses);
    }
  }, [selectAddressDrawer, addressList]);
  const handleAddressDialogOpen = () => {
    setAddressCreateFrom("CART_SIDE_NAV");
    setAddressDialogOpen(true);
    toggleSelecteAddressDrawer(false)();
  };
  const Title = styled(Typography)({
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "left",
    lineHeight: "150%",
    color: "var(--neutral-800)",
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  });

  return (
    <div>
      <React.Fragment>
        <Drawer
          open={selectAddressDrawer}
          anchor={isMobile ? "bottom" : "right"}
          onClose={toggleSelecteAddressDrawer(false)}
        >
          <Box
            sx={{
              width: {
                xs: "100vw",
                sm: "100vw",
                md: addressList?.length > 2 ? 750 : 600,
              },
              justifyContent: "space-between",
              display: "flex",
              p: 4,
              pt: 2,
              flexDirection: "column",
              gap: 3,
              // height: isMobile ? "auto" : "100vh",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(255,250,242,0.96) 100%)",
            }}
          >
            <Grid container>
              <Grid size={12}>
                <Box
                  sx={{
                    justifyContent: "center",
                    display: "flex",
                    // mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={bfLogo}
                    alt="Utsav Pack"
                    sx={{
                      height: { xs: "60px", md: "70px", lg: "85px" },
                      width: "auto",
                    }}
                  />
                  <IconButton
                    sx={{ position: "absolute", right: 24, top: 24 }}
                    onClick={toggleSelecteAddressDrawer(false)}
                  >
                    <X size={20} />
                  </IconButton>
                </Box>
              </Grid>
              <Grid size={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <Title>Select Address</Title>
                  <NavLink
                    to="/account/my-address"
                    style={{
                      fontSize: 14,
                      color: "var(--primary-red-base)",
                      whiteSpace: "nowrap",
                      textDecoration: "underline",
                    }}
                  >
                    <IconButton aria-label="manage address">
                      <AddressBook
                        size={18}
                        color="var(--primary-red-base)"
                      />
                    </IconButton>
                    Address Book
                  </NavLink>
                </Box>

                <CartAddressList
                  addressList={localAddressList}
                  primaryAddress={primaryAddress}
                  primaryAddressRefetch={primaryAddressRefetch}
                  setSelectedAddress={setSelectedAddress}
                  selectedAddress={selectedAddress}
                  addressListFetch={addressListFetch}
                />
              </Grid>

              <Grid size={12} sx={{ mt: 2 }}>
                <Button
                  startIcon={
                    <InfoOutlinedIcon sx={{ color: "var(--neutral-800)" }} />
                  }
                  color="error"
                  onClick={() => setOpenGstDialog(true)}
                  sx={{
                    fontSize: { xs: "11px", sm: "12px" },
                    p: { xs: 0.5, sm: 1 },
                    whiteSpace: "nowrap",
                  }}
                >
                  Add GST invoice details (optional)
                </Button>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Button
                onClick={handleAddressDialogOpen}
                variant="outlined"
                sx={{
                  py: 1,
                  fontSize: { xs: "14px", sm: "16px" },
                  width: "100%",
                  border: "1px solid var(--primary-red-base)",
                  borderRadius: "12px",
                }}
              >
                Add new address
              </Button>
              <Button
                onClick={toggleSelecteAddressDrawer(false)}
                variant="contained"
                sx={{
                  py: 1,
                  fontSize: { xs: "14px", sm: "16px" },
                  width: "100%",
                  border: "1px solid var(--primary-red-base)",
                  borderRadius: "12px",
                }}
                id="continue-button"
              >
                Use selected address
              </Button>
            </Box>
          </Box>
        </Drawer>
        <GstInvoice
          open={openGstDialog}
          onClose={() => setOpenGstDialog(false)}
          gstInvoiceDetails={gstInvoiceDetails}
          setGstInvoiceDetails={setGstInvoiceDetails}
        />
      </React.Fragment>
    </div>
  );
}
